let updater;

document.addEventListener('DOMContentLoaded', updateCounter);
document.addEventListener('resize', updateCounter);
document.addEventListener('scroll', updateCounter);

function isElementInViewport(el) {
    let rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function updateCounter() {
    let counters = document.querySelectorAll('.counter__value');
    let interval = 20;

    if (counters.length > 0) {
        if (isElementInViewport(counters[0])) {
            let min = parseFloat(counters[0].dataset.min);
            let current = parseFloat(counters[0].dataset.current);

            if (current <= min) {
                updater = setInterval(update, interval);
            }
        }
    }

    function update() {
        let finished = true;
        counters.forEach(function (counter) {
            let min = parseFloat(counter.dataset.min);
            let max = parseFloat(counter.dataset.max);
            let current = parseFloat(counter.dataset.current);
            let speed = parseFloat(counter.dataset.speed);

            let change;

            if (current < max) {
                change = (max - min) / (speed / interval);
                counter.dataset.current = current + change;
                finished = false;
            } else {
                next = max;
            }

            let value = (counter.dataset.current > max) ? max : parseInt(counter.dataset.current * 10) / 10
            counter.innerHTML = value + ' Mio';
        });

        if (finished) {
            clearInterval(updater);
        }
    }
}


